import type { SkillBarState } from "@/character/skills/types";

const DB_NAME = "mind-survival-home";
const STORE = "rooms";
const DB_VERSION = 1;

function skillBarKey(userId: string): string {
  return `skills:${userId}`;
}

let dbPromise: Promise<IDBDatabase> | null = null;

function openDb(): Promise<IDBDatabase> {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error ?? new Error("เปิด IndexedDB ไม่สำเร็จ"));
  });
  return dbPromise;
}

function idbGet<T>(key: string): Promise<T | null> {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, "readonly");
        const req = tx.objectStore(STORE).get(key);
        req.onsuccess = () => resolve((req.result as T | undefined) ?? null);
        req.onerror = () => reject(req.error ?? new Error("อ่าน IndexedDB ไม่สำเร็จ"));
      }),
  );
}

function idbSet(key: string, value: unknown): Promise<void> {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, "readwrite");
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error ?? new Error("เขียน IndexedDB ไม่สำเร็จ"));
        tx.objectStore(STORE).put(value, key);
      }),
  );
}

export async function loadSkillBarFromIdb(userId: string): Promise<SkillBarState | null> {
  try {
    return await idbGet<SkillBarState>(skillBarKey(userId));
  } catch {
    return null;
  }
}

export async function saveSkillBarToIdb(userId: string, bar: SkillBarState): Promise<void> {
  await idbSet(skillBarKey(userId), bar);
}
